const warehousepurchaseDt = require('./warehousepurchase-dt')
const page                = require('../../../../components/page/page')
//const historynurseDt = require('./historynurse-dt')

import warehousepurchasePage       from "./warehousepurchase-page.html";


/****************ELEMENTS*****************/
var HTMLwasSelected  = false

//insert the page  on the body
function HTMLselect(detail){ //console.log('goku init>', detail)
	
	HTMLwasSelected = true

	//load the page to the index
   const body = document.body
   body.insertAdjacentHTML("beforeend", warehousepurchasePage)

   warehousepurchaseDt.start({"dest":"warehousepurchase", "elem":"dt", "act":"select", "entity":"warehousepurchase"})

}/*init*/

/****************ELEMENTS*****************/

export function start(detail){ //console.log('investor page >', detail)
  
   if(!HTMLwasSelected) {HTMLselect(detail)}
	
	 obj[detail.act].start(detail)
}

const obj = {
   
   show:  { start: (detail)=>{  page.start(detail)     }},

}/**/